/**
 * Define util mixin
 *
 * @author sohyun.ahn@emcast.com
 */

import Moment from "moment-timezone";
import { dateConstants } from "@/utils/constants/DateConstants";

const defaultHour = 60;

export const utilDateMixin = {
  data() {
    return {
      today: new Date(),
      changeTime: new Date(),
      changeDate: new Date(),
      index: 1
    };
  },

  created() {
    Moment.locale(
      localStorage.getItem("languageInfo")
        ? JSON.parse(localStorage.getItem("languageInfo")).code
        : "en"
    );
  },

  methods: {
    // 날짜별 yyyy.mm.dd 또는 mm/dd/yyyy 표기법을 위한 공통 메소드 - 0
    dayFormatter(changeDate) {
      return Moment(changeDate).format("L");
    },

    // 시간별 hh:mm 표기법을 위한 공통 메소드
    timeFormat(changeTime) {
      return Moment(changeTime).format("HH:mm");
    },

    padToTwoDigits(num) {
      return num.toString().padStart(2, "0");
    },

    toHoursAndMin(totalMin) {
      const hourAndMinute = this.hourAndMinute(totalMin);
      return `${hourAndMinute.hour}:${this.padToTwoDigits(
        hourAndMinute.minute
      )}`;
    },

    runningTimeFormat(totalMin) {
      const hourAndMinute = this.hourAndMinute(totalMin);
      const minuteFormat =
        this.padToTwoDigits(hourAndMinute.minute) + this.$t("30010");

      if (totalMin <= defaultHour) {
        return minuteFormat;
      } else {
        return hourAndMinute.hour + this.$t("30009") + "\n" + minuteFormat;
      }
    },

    hourAndMinute(totalMin) {
      return {
        hour: Math.floor(totalMin / defaultHour),
        minute: Math.floor(totalMin % defaultHour)
      };
    },

    toHoursAndMinutes(totalSeconds) {
      const totalMinutes = Math.floor(totalSeconds / 60);

      const seconds = totalSeconds % 60;
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return {h: hours, m: minutes, s: seconds};
    },

		// 날짜 변환(change date format)
		displayPeriod(dateInfo) {
			const startDate = this.$moment(dateInfo.start).format("L");
			const endDates =
				dateInfo.unlimited || dateInfo.end >= dateConstants.maximumDate
					? this.$t("50013")
					: this.$moment(dateInfo.end).format("L");
			return `${startDate} ~ ${endDates}`;
		},

    displayEndPeriod(endDate) {
      return endDate >= dateConstants.maximumDate ? this.$t('50013') : this.$moment(endDate).format('L')
    }
  }
};
